module.exports = __webpack_public_path__ + "img/5df58a06fb1491ec9266938a39fc48b9.73141ed5.jpg";